import userImag from "../../assets/images/model/user_img.png";
import plus from "../../images/plus_color.svg";
import checkBox from "../../assets/images/check_box.svg";
import close_1 from "../../assets/images/close-circle.svg";
import angleDown from "../../assets/images/model/angle-down.png";
import draggArrow from "../../assets/images/model/draggArrow.svg";
import image from "../../assets/images/model/image-icon.svg";
import vidoe from "../../assets/images/model/video_icon.svg";
import audio from "../../assets/images/model/audio-icon.svg";
import plusCricle from "../../assets/images/model/plus-addmedia.svg";
import React, { Fragment, useEffect, useRef, useState } from "react";
import "./createbook.css";
import "./createbookresponsive.css";
import PickLibSidebar from "../../components/createmode/PickLibSidebar";
import { useDispatch, useSelector } from "react-redux";
import { setSiteMode, resetSiteMode } from "../../Store/settings/siteSettings";
import { setChapter, setSection } from "../../Store/ui/reader";
import Modal from "../../components/Modal";
import dimond from "../../assets/images/greyled-activity.svg";
import InnerHeader from "../../components/InnerHeader";
import mult_choice from "../../images/mult_choice.png";
import free_response from "../../images/free_response.png";
import fill_in_the_blank from "../../images/fill_in_the_blank.png";
import matching from "../../images/matching.png";
import OutlineElement from "../../components/OutlineElement";
import DeleteModal from "../../components/DeleteModal";
import moment from "moment";
import ActivitySetModal from "../../components/AvtivitySetModal";
import UploadedVideo from "./addMedia/UploadedVideo";
import UploadAudio from "./addMedia/UploadAudio";
import UploadingVideo from "./addMedia/UploadingVideo";
import UploadVideo from "./addMedia/UploadVideo";
import UploadedImage from "./addMedia/UploadedImage";
import UploadingImages from "./addMedia/UploadingImage";
import UploadImage from "./addMedia/UploadImage";
import GreyledHeader from "../../components/createmode/created";
import PickLibRightsidebar from "../../components/createmode/PickLibRightsidebar";
import HtmlAsText from "../../components/createmode/HtmlAsText";

const currentDate = new Date();

const currentMonth = moment().month();
const daysInMonth = moment().daysInMonth();

const datesArray = [];
for (let day = 1; day <= daysInMonth; day++) {
  const date = moment().month(currentMonth).date(day);
  datesArray.push(date.date());
}
const PickFromActivity = () => {
  // const { settings } = useSelector((state) => state.settings);
  const { reader } = useSelector((state) => state.ui.reader);

  const { book } = useSelector((state) => state.entities);
  const { loaders } = useSelector((state) => state.ui);
  const { settings } = useSelector((state) => state.settings.settings);
  const { chapter, section, topScroll } = reader;
  const currentChapter = book.chapters[chapter];

  const [scrollToId, setScrollToId] = useState(null);
  const [highlightedSection, setHighlightedSection] = useState(null);
  const [showCalendar, setShowCalendar] = useState(undefined);
  const [createActivity, setCreateActivity] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  const [creatingActivity, setCreatingActivity] = useState(undefined);
  const [draggedOver, setDraggedOver] = useState(null);
  const [writingActivity, setWritingActivity] = useState(false);

  const [reverse, setReverse] = useState(false);
  const [highlightedIndexes, setHighlightedIndexes] = useState([]);
  const [pTop, setPtop] = useState(0);
  const [outlineHeight, setOutlineHeight] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const [isResizingUp, setIsResizingUp] = useState(true);
  const [draggedChap, setDraggedChap] = useState("");
  const [selectedParagraphs, setSelectedParagraphs] = useState([]);

  const [isScrolling, setIsScrolling] = useState(false);
  const [highlightedParagraph, setHighlightedParagraph] = useState(null);
  const [isDraggingActivity, setIsDraggingActivity] = useState(false);
  const [draggedActivity, setDraggedActivity] = useState(null);

  const [activities, setActivities] = useState([]);
  const [greyedItem, setGreyedItem] = useState("");
  const [greyedParagraphs, setGreyedPharagraphs] = useState([]);
  const [chapters, setChapters] = useState([
    book.chapters[0] || { sections: [] },
  ]);
  const [draggedActivityPosition, setDraggedActivityPosition] = useState({
    top: 0,
    left: 0,
  });
  const [activitySetModal, setActivitySetModal] = useState({
    show: false,
    choice: "",
  });

  const dispach = useDispatch();
  const scrollerRef = useRef(null);
  let timerId = null;

  useEffect(() => {
    const outlineComponent = document.getElementById("outline_component");

    if (isResizing || !outlineComponent) return;

    timerId = setTimeout(() => {
      let prevParagraph;
      let paragraphs = [];
      let sectionPasses = false;
      let firstParagraphPasses = false;
      const currentSection = draggedChap.split(".")[1];
      const pElements = document.getElementsByClassName("unique_paragraph");
      const { offsetTop: fTop } = pElements[0];
      const { top: outlineTop, bottom } =
        outlineComponent.getBoundingClientRect();

      //snap back the top to first paragraph of the selected section if it exceeds the section from the top
      if (pTop < fTop) {
        for (let j = 0; j < pElements.length; j++) {
          const {
            offsetTop,
            dataset: { secid: secidj },
          } = pElements[j];
          if (secidj === currentSection) {
            const diff = offsetTop - pTop;
            setPtop(offsetTop);
            setOutlineHeight((prev) => prev - diff);
            return;
          }
        }
      }

      for (let i = 0; i < pElements.length; i++) {
        const {
          offsetTop,
          dataset: { id, secid },
        } = pElements[i];
        const { top, bottom: pBottom } = pElements[i].getBoundingClientRect();

        if (
          (outlineTop <= top && top <= bottom) ||
          (top <= outlineTop && outlineTop <= pBottom) ||
          (top <= bottom && bottom <= pBottom)
        ) {
          const mid = top + (pBottom - top) / 2;

          if (secid === currentSection) {
            sectionPasses = true;
            prevParagraph = pElements[i];
          } else if (prevParagraph) {
            //snap back the bottom to bottom of the last paragraph of the selected section if it exceeds the section from bottom

            const { bottom: pBottom } = prevParagraph.getBoundingClientRect();

            if (bottom > pBottom) {
              setPtop(pTop);
              setOutlineHeight((prev) => prev - (bottom - pBottom));
              return;
            }
          }

          if (secid !== currentSection) {
            // Paragraph of other sections
            if (!sectionPasses) {
              // current section not passed yet and other section paragraph is in selection then find first paragraph of current section

              for (let j = i; j < pElements.length; j++) {
                const {
                  offsetTop,
                  dataset: { secid: secidj },
                } = pElements[j];
                if (secidj === currentSection) {
                  const diff = offsetTop - pTop;
                  setPtop(offsetTop);
                  setOutlineHeight((prev) => prev - diff);
                  return;
                }
              }
            } else {
              // current section has passed and other section paragraph is in selection then find previous paragraph of current section

              const { bottom: pBottom } = prevParagraph.getBoundingClientRect();

              setPtop(pTop);
              setOutlineHeight((prev) => prev - (bottom - pBottom));
              return;
            }
          } else {
            if (!firstParagraphPasses) {
              if (outlineTop <= mid) {
                if (Math.floor(outlineTop - top) > 2) {
                  // snap back to start of the first paragraph if selection top is less than paragraph mid

                  setPtop(offsetTop);
                  setOutlineHeight((prev) => prev + (outlineTop - top));

                  return;
                }
              } else {
                if (bottom <= pBottom) {
                  setPtop(offsetTop);
                  setOutlineHeight((prev) => prev + (outlineTop - top));
                  return;
                } else {
                  if (i < pElements.length - 1) {
                    const {
                      offsetTop: nTop,
                      dataset: { secid: secidn },
                    } = pElements[i + 1];

                    if (secidn === currentSection) {
                      setPtop(nTop);
                      setOutlineHeight((prev) => prev - (nTop - pTop));

                      return;
                    }
                  }
                }
              }
            }

            firstParagraphPasses = true;
          }

          paragraphs.push(id);
        }
      }

      if (prevParagraph && !isResizingUp) {
        const {
          bottom: pBottom,
          top: prTop,
          height: prHeight,
        } = prevParagraph.getBoundingClientRect();
        //snap back to bottom of the last paragraph of the selected section if it exceeds the section from bottom
        const {
          dataset: { secid: prSecId },
        } = prevParagraph;

        /**
         * snap the bottom to the bottom of the current paragraph if the outline is more then 50% down
         * OR
         * also snap the bottom to the bottom of the current paragraph if paragraph top is less or equal to outline top
         **/
        if (outlineTop >= prTop && pBottom - bottom > 5) {
          setPtop(pTop);
          setOutlineHeight((prev) => prev + (pBottom - bottom));
          // return;
        } else {
          if ((pBottom - prTop) / 2 + prTop > bottom) {
            setPtop(pTop);
            setOutlineHeight((prev) => prev - (bottom - prTop));
          } else if (pBottom - bottom > 5) {
            setPtop(pTop);
            setOutlineHeight((prev) => prev + (pBottom - bottom));
          }
        }
      }

      setSelectedParagraphs(paragraphs);
    }, 100);

    return () => {
      clearTimeout(timerId);
    };
  }, [pTop, outlineHeight, isResizing, isResizingUp]);

  useEffect(() => {
    dispach(setSiteMode("teach"));
    return () => {
      dispach(resetSiteMode());
    };
  }, []);
  useEffect(() => {
    setActivities(book.activities);
    setChapters([book.chapters[0]]);
    return () => {};
  }, [book]);

  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);
      if (div) {
        div.scrollIntoView({ block: "start" });
        setScrollToId(null);
      }
    }
  }, [scrollToId]);

  useEffect(() => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollTop = topScroll;
    }
  }, [scrollerRef.current]);

  const scrollableContent = (scroller) => {
    scrollerRef.current = scroller;
  };

  const scrollToSection = (sec, chap, par = null) => {
    if (chapters.length <= chap) {
      const lowerInd = chapters.length - 1;
      const chapsToPush = book.chapters.slice(lowerInd + 1, chap + 1);
      setChapters([...chapters, ...chapsToPush]);
    }

    const chapt = book.chapters[chap];
    const sect = chapt.sections[sec];

    let sectionId = chapt && sect ? `${chapt._id}.${sect._id}` : `${chapt._id}`;
    if (par) sectionId += `.${par}`;
    setScrollToId(sectionId);
  };

  const scrollToChapter = (chap, chapSec) => {
    if (chapters.length <= chapSec) {
      const lowerInd = chapters.length - 1;
      const chapsToPush = book.chapters.slice(lowerInd + 1, chapSec + 1);
      setChapters([...chapters, ...chapsToPush]);
    }
    setScrollToId(chap);
  };

  const scrollToParagraph = (chap, sec, par) => {
    if (chapters.findIndex((e) => e._id === chap) < 0) {
      const chapIndex = book.chapters.findIndex((e) => e._id == chap);
      //TODO, API call
      const lowerInd = chapters.length - 1;
      const chapsToPush = book.chapters.slice(lowerInd + 1, chapIndex + 1);
      setChapters([...chapters, ...chapsToPush]);
    }
    setScrollToId(`${chap}.${sec}.${par}`);
  };
  const highlightChapter = (e, value) => {
    setGreyedItem("");
    setGreyedPharagraphs([]);
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setActivities(book.activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSection(value);
      setActivities(book.activities.filter((e) => e.chapter === value));
      // setScrollToId(value);
    }
  };
  const highlightSection = (e, value) => {
    setGreyedItem("");
    setGreyedPharagraphs([]);
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setActivities(book.activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSection(value);
      setActivities(
        book.activities.filter(
          (e) => e.section === value && e.paragraphs.length === 0
        )
      );
      // setScrollToId(value);
    }
  };

  const greyedItemSetter = (activity) => {
    if (!activity.section && activity.paragraphs.length === 0) {
      if (greyedItem === activity.chapter) {
        setGreyedItem("");
      } else {
        setGreyedItem(activity.chapter);
      }
    } else if (activity.section && activity.paragraphs.length === 0) {
      if (greyedItem === activity.section) {
        setGreyedItem("");
      } else {
        setGreyedItem(activity.section);
      }
    } else {
      if (
        JSON.stringify(greyedParagraphs) == JSON.stringify(activity.paragraphs)
      ) {
        setGreyedPharagraphs([]);
      } else {
        setGreyedPharagraphs(activity.paragraphs);
      }
    }
  };

  const setCalendarShow = (bool) => {
    setShowCalendar(bool);
  };

  const reverseIt = (e) => {
    setReverse(!reverse);
  };

  const handleCenterFoldScroll = (event) => {
    const element = event.target;
    // if (element.scrollTop === 0) {
    //

    //   if (chapter > 0) {
    //     element.scrollTop = element.scrollHeight / 4;
    //     dispach(setChapter(chapter - 1))
    //     // dispach(setSection(0))
    //   };
    // }
    if (
      approximatelyEqual(
        element.scrollHeight,
        element.scrollTop,
        element.clientHeight
      )
    ) {
      if (chapter < book.chapters.length - 1) {
        //TODO, API call and get the next chapter from db
        setChapters([...chapters, book.chapters[chapters.length]]);
        dispach(setChapter(chapter + 1));
        // dispach(setSection(0))
        // element.scrollTop = 5
      }
    }
    const parentElement = event.target;
    const chapChildren = Array.from(parentElement.children).filter((e) =>
      e.classList.contains("chapter_element")
    );
    let sectionElements = chapChildren.map((e) =>
      Array.from(e.children).filter((e) =>
        e.classList.contains("section_element")
      )
    );
    sectionElements = sectionElements.flat();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    for (let i = 0; i < chapChildren.length; i++) {
      const rect = chapChildren[i].getBoundingClientRect();
      if (
        rect.top >= 0 &&
        rect.top <= viewportHeight &&
        rect.left >= 0 &&
        rect.left <= viewportWidth
      ) {
        const targetChild = chapChildren[i];
        const chapter = Number(targetChild.dataset.id);
        dispach(setChapter(chapter));
        break;
      }
    }
    for (let i = 0; i < sectionElements.length; i++) {
      const rect = sectionElements[i].getBoundingClientRect();
      if (
        rect.top >= 0 &&
        rect.top <= viewportHeight &&
        rect.left >= 0 &&
        rect.left <= viewportWidth
      ) {
        const targetChild = sectionElements[i];
        const sectId = targetChild.dataset.id.split(".")[1];
        const sectInd = currentChapter.sections.findIndex(
          (e) => e._id === sectId
        );
        if (sectInd >= 0) dispach(setSection(sectInd));
        break;
      }
    }
  };

  function approximatelyEqual(num1, num2, num3) {
    const diff = Math.abs(num1 - num2);
    return Math.abs(diff - num3) <= 10;
  }

  const calculateTotalHeight = () => {
    let totalHeight = 0;
    let top = Infinity;
    const pElements = document.getElementsByClassName("activated_p_tags");
    if (pElements.length) {
      for (let i = 0; i < pElements.length; i++) {
        totalHeight += pElements[i].offsetHeight;
      }
      top = Math.min(top, pElements[0].offsetTop);
      setPtop(top);
    }

    return totalHeight;
  };
  useEffect(() => {
    setOutlineHeight(calculateTotalHeight());
  }, [highlightedIndexes]);

  const resizingSet = (value, up, e) => {
    e.stopPropagation();
    setIsResizing(value);
    setIsResizingUp(up);
  };

  const handleResizing = (e) => {
    if (!isResizing && !dragging) return;
    // const newHeight = isResizingUp? outlineHeight - event.movementY : outlineHeight + event.movementY;

    const container = scrollerRef.current;
    const containerHeight = container.clientHeight;
    const scrollHeight = container.scrollHeight;
    const scrollTop = container.scrollTop;
    let additionalHeight = 0;
    // Check if the mouse movement is towards the bottom
    if (e.clientY > containerHeight - 50) {
      // Check if the content is not already scrolled to the bottom
      if (scrollTop < scrollHeight - containerHeight) {
        // Scroll the content further down by adding a small amount to scrollTop
        container.scrollTop += 5; // Adjust the scroll speed as per your preference
        additionalHeight += 5;
      }
    } else {
    }
    setOutlineHeight(
      isResizingUp
        ? outlineHeight - e.movementY
        : outlineHeight + e.movementY + additionalHeight
    );
    setPtop(isResizingUp ? pTop + e.movementY + additionalHeight : pTop);
  };

  const dynamicPStyles = (chap, section, paragraph) => {
    let className = "theme_para_se paragraph_element main_p";

    className +=
      book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) >
      -1
        ? " rich"
        : "";
    className += settings.fontLarge ? " fontLarge" : "";
    className += highlightedIndexes.includes(
      `${chap._id}.${section._id}.${paragraph._id}`
    )
      ? " activated_p_tags"
      : "";
    className +=
      highlightedParagraph === paragraph._id ||
      greyedParagraphs.includes(paragraph._id)
        ? " bg_grey"
        : "";

    return className;
  };

  const dynamicSectionStyles = (chap, section) => {
    let className = "section_element";
    className += settings.fontLarge ? " fontLarge" : "";
    className +=
      highlightedSection === `${section._id}` || greyedItem === section._id
        ? " highlighted"
        : "";
    className +=
      draggedOver &&
      draggedOver.type === "section" &&
      draggedOver.index == `${chap._id}.${section._id}`
        ? " trigger"
        : "";

    return className;
  };

  return (
    <div>
      <section className="class_room_wrap teach mt-0">
        <div>
          <div
            className={`flex-container`}
            onMouseMove={(event) => {
              event.preventDefault();
              if (isDraggingActivity) {
                setDraggedActivityPosition({
                  top: (event.clientY / window.innerHeight) * 100,
                  left: (event.clientX / window.innerWidth) * 100,
                });
              }
              if (!dragging) return;
              const left = (event.clientX / window.innerWidth) * 100; // percentage of viewport width
              const top = (event.clientY / window.innerHeight) * 100; // percentage of viewport height
              setMousePosition({ x: left, y: top });
              if (isScrolling) {
                const { clientY: y } = event;
                const { scrollTop } = scrollerRef.current;
                scrollerRef.current.scrollTop = scrollTop + y;
              }
            }}
            onMouseUp={(e) => {
              if (isResizing) setIsResizing(false);
              if (isScrolling) setIsScrolling(false);
              if (isDraggingActivity) {
                setIsDraggingActivity(false);
              }
              e.stopPropagation();
            }}
          >
            {/*  <div className="activity-spectrum">
              <div>
                <DraggableSidebar
                  scrollPara={scrollToParagraph}
                  scrollBook={scrollToSection}
                  scrollToSection={scrollToSection}
                  scrollToParagraph={scrollToParagraph}
                  scrollToChapter={scrollToChapter}
                  setParentIsScrolling={setIsScrolling}
                  scrollCentre={scrollWithSpectrum}
                  isScrolling={isScrolling}
                  setScrollToId={setScrollToId}
                />
              </div>
            </div> */}
            <div className="side-nav">
              {
                <PickLibSidebar
                  isDraggingActivity={isDraggingActivity}
                  draggedActivity={draggedActivity}
                  draggedOver={draggedOver}
                  anchorBook={scrollToParagraph}
                  scrollChapter={scrollToChapter}
                  scrollSection={scrollToSection}
                  handleCalnendarShow={setCalendarShow}
                />
              }
            </div>
            <div className="centre-fold" style={{ width: "75%" }}>
              <div style={{ padding: "10px 0px" }}>
                <GreyledHeader />
              </div>
              <div className={`row ${reverse ? "reverse" : ""}`}>
                <div className="col-xl-7 col-lg-12">
                  <InnerHeader
                    highlightedSection={highlightedSection}
                    writingActivity={writingActivity}
                    creatingActivity={creatingActivity}
                  />
                  <div
                    className="center_content"
                    ref={scrollableContent}
                    onScroll={handleCenterFoldScroll}
                    onMouseMove={handleResizing}
                  >
                    {!loaders.bookLoader ? (
                      <Fragment>
                        {chapters.map((chap, chapInd) => (
                          <div
                            className={`book chapter_element ${
                              highlightedSection === chap._id ||
                              greyedItem === chap._id
                                ? "highlighted"
                                : ""
                            }`}
                            data-id={chapInd}
                            key={chapInd}
                            id={chap._id}
                            style={{ position: "relative" }}
                          >
                            {book.activities.findIndex(
                              (e) => e.chapter === chap._id && !e.section
                            ) > -1 && (
                              <img
                                src={dimond}
                                alt="diamond"
                                className="cursor"
                                onClick={(e) => {
                                  setHighlightedParagraph(null);
                                  setGreyedPharagraphs([]);
                                  highlightChapter(e, `${chap._id}`);
                                }}
                                style={{
                                  position: "absolute",
                                  top: 3,
                                  right: 5,
                                }}
                              />
                            )}
                            <h4
                              className={`sub_heading max_550 chapter_element w-95 ${
                                draggedOver &&
                                draggedOver.type === "chapter" &&
                                draggedOver.index == chap._id
                                  ? "trigger"
                                  : ""
                              }`}
                              data-id={chap._id}
                            >
                              {chap.title}
                            </h4>
                            <p
                              className={
                                settings.fontLarge
                                  ? "theme_para_se chapter_element fontLarge"
                                  : "theme_para_se chapter_element"
                              }
                              data-id={chap._id}
                            >
                              {/* {chap.description} */}
                              <HtmlAsText htmlContent={chap?.description} />
                            </p>
                            <hr className="activity-line" />
                            {chap.sections.map((section, secIndex) => (
                              <div
                                key={secIndex}
                                id={`${chap._id}.${section._id}`}
                                data-id={`${chap._id}.${section._id}`}
                                className={dynamicSectionStyles(chap, section)}
                                style={{ position: "relative" }}
                              >
                                {book.activities.findIndex(
                                  (e) =>
                                    e.section == section._id &&
                                    !e.paragraphs.length
                                ) > -1 ? (
                                  <img
                                    src={dimond}
                                    alt="diamond"
                                    className="cursor"
                                    onClick={(e) => {
                                      setHighlightedParagraph(null);
                                      setGreyedPharagraphs([]);
                                      highlightSection(e, `${section._id}`);
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: 3,
                                      right: 4,
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                                <h5
                                  className={`mt-3 w-95 ${
                                    book.activities.findIndex(
                                      (e) => e.section == section._id
                                    ) > -1
                                      ? "rich"
                                      : ""
                                  }`}
                                >
                                  {section.title}
                                </h5>

                                {section.description ? (
                                  <p>{section.description}</p>
                                ) : (
                                  ""
                                )}

                                {highlightedIndexes.length > 0 &&
                                draggedChap === `${chap._id}.${section._id}` ? (
                                  <OutlineElement
                                    top={pTop}
                                    height={outlineHeight}
                                    resizingSet={resizingSet}
                                  />
                                ) : (
                                  ""
                                )}
                                {[...section.paragraphs]
                                  .sort((a, b) => a._id - b._id)
                                  .map((paragraph, index) => (
                                    <div
                                      key={index}
                                      className={`${
                                        draggedOver &&
                                        draggedOver.type === "paragraph" &&
                                        draggedOver.index ==
                                          `${chap._id}.${section._id}.${paragraph._id}`
                                          ? "trigger"
                                          : ""
                                      } main-pera-wraper unique_paragraph ${
                                        isResizing ? "resizing" : "cursor"
                                      } ${
                                        greyedParagraphs.includes(paragraph._id)
                                          ? "bg_grey"
                                          : ""
                                      }`}
                                      data-id={paragraph._id}
                                      data-secid={section._id}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setCalendarShow(false);
                                      }}
                                    >
                                      {paragraph.title && (
                                        <h6
                                          className={`mini_heading paragraph_element w-95 `}
                                          data-id={paragraph._id}
                                        >
                                          {paragraph.title}
                                        </h6>
                                      )}
                                      <div
                                        className={dynamicPStyles(
                                          chap,
                                          section,
                                          paragraph
                                        )}
                                        data-id={`${chap._id}.${section._id}.${paragraph._id}`}
                                        key={index}
                                        id={`${chap._id}.${section._id}.${paragraph._id}`}
                                        style={{ position: "relative" }}
                                      >
                                        {book.activities.findIndex(
                                          (e) =>
                                            e.paragraphs.includes(
                                              paragraph._id
                                            ) &&
                                            (e.paragraphs.length === 1 ||
                                              [...e.paragraphs]
                                                .sort((a, b) => a - b)
                                                .indexOf(paragraph._id) === 0)
                                        ) > -1 && (
                                          <img
                                            src={dimond}
                                            alt="diamond"
                                            className="cursor"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setHighlightedSection(null);
                                              setGreyedPharagraphs([]);
                                              setGreyedItem("");

                                              if (
                                                highlightedParagraph ===
                                                paragraph._id
                                              ) {
                                                setHighlightedParagraph(null);
                                                setGreyedItem("");
                                                setActivities(book.activities);
                                              } else {
                                                setHighlightedParagraph(
                                                  paragraph._id
                                                );
                                                setGreyedPharagraphs(
                                                  book.activities
                                                    .filter((e) =>
                                                      e.paragraphs.includes(
                                                        paragraph._id
                                                      )
                                                    )
                                                    .flatMap(
                                                      (obj) => obj.paragraphs
                                                    )
                                                );
                                                setActivities(
                                                  book.activities.filter((e) =>
                                                    e.paragraphs.includes(
                                                      paragraph._id
                                                    )
                                                  )
                                                );
                                              }
                                            }}
                                            style={{
                                              position: "absolute",
                                              top: 8,
                                              right: -4,
                                            }}
                                          />
                                        )}
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: paragraph.text,
                                          }}
                                        ></div>

                                        {paragraph.video &&
                                        paragraph.video.link ? (
                                          <div>
                                            <video
                                              src={paragraph.video.link}
                                              controls
                                              width="100%"
                                            />
                                            <span>
                                              {paragraph.video.description}
                                            </span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {paragraph.image &&
                                        paragraph.image.link ? (
                                          <div>
                                            <img src={paragraph.image.link} />
                                            <span>
                                              {paragraph.image.description}
                                            </span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            ))}
                            <div
                              className="chapter_element"
                              data-id={chap._id}
                              style={{ width: "100%", height: "1px" }}
                            ></div>
                          </div>
                        ))}
                      </Fragment>
                    ) : (
                      <Fragment>
                        <div>Loading...</div>
                      </Fragment>
                    )}

                    {/* {!creatingActivity && !writingActivity ? ( */}
                    <div
                      className="page_nation teach"
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        height: "auto",
                      }}
                      id="calendar-button"
                    >
                      <div className="bottom_button_wrap">
                        <button type="button" className="btn_white_outline">
                          Save changes
                        </button>
                        <button type="button" className="btn_white_outline">
                          Push changes to class
                        </button>
                      </div>
                    </div>
                    {/* ) : (
                      ""
                    )} */}
                  </div>
                </div>
                <div className="col-xl-5 col-lg-12">
                  <PickLibRightsidebar
                    creatingActivity={creatingActivity}
                    writingActivity={writingActivity}
                    setCreatingActivity={setCreatingActivity}
                    setWritingActivity={setWritingActivity}
                    setDraggedOver={setDraggedOver}
                    setHighlightedIndexes={setHighlightedIndexes}
                    setReverse={setReverse}
                    reverseIt={reverseIt}
                    selectedParagraphs={selectedParagraphs}
                    draggedChap={draggedChap}
                    dragging={dragging}
                    scrollToParagraph={scrollToParagraph}
                    scrollToSection={scrollToSection}
                    draggedActivity={draggedActivity}
                    isDraggingActivity={isDraggingActivity}
                    setDraggedActivity={setDraggedActivity}
                    greyedItemSetter={greyedItemSetter}
                    draggedActivityPosition={draggedActivityPosition}
                    setMousePosition={setMousePosition}
                    mousePosition={mousePosition}
                    showCalendar={showCalendar}
                    reverse={reverse}
                    highlightedSection={highlightedSection}
                    activities={activities}
                    setActivitySetModal={setActivitySetModal}
                    setDraggedActivityPosition={setDraggedActivityPosition}
                    setDragging={setDragging}
                    setIsDraggingActivity={setIsDraggingActivity}
                    scrollToChapter={scrollToChapter}
                    setDraggedChap={setDraggedChap}
                    hitBottom={handleResizing}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          handleCalnendarShow={setCalendarShow}
          isDraggingActivity={isDraggingActivity}
          draggedActivity={draggedActivity}
          setDraggedActivityPosition={setDraggedActivityPosition}
          setIsDraggingActivity={setIsDraggingActivity}
          showCalendar={showCalendar}
          setShowCalendar={setShowCalendar}
        />
      </section>
      {<DeleteModal />}
      <ActivitySetModal
        show={activitySetModal.show}
        options={activitySetModal}
        setActivitySetModal={setActivitySetModal}
        setCreatingActivity={setCreatingActivity}
      />
    </div>
  );
};

export default PickFromActivity;
